// extracted by mini-css-extract-plugin
export default {"amazonPayModeSection":"Z0-z"};